declare global {
    interface Window {
        hotkeys: Record<'unbind', (...args: any[]) => void>;
    }
}


export function unbindSvelteSheetsHotkeys() {
    window.hotkeys?.unbind?.();
}

